import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('CLASS_MEMBER_TYPE')